<template>
  <v-row>
    <v-col>
      <v-card class="mb-3">
        <v-card-text class="d-flex justify-end">
          <v-btn size="small" @click="openNewMiqaat">Add Miqaat</v-btn>
        </v-card-text>
      </v-card>

      <data-table :tableData="tableData" :disablePagination="true">
        <template v-slot:[`item.startDate`]="{ item }">
          {{ moment(item.startDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.endDate`]="{ item }">
          {{ moment(item.endDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.registrationStartDate`]="{ item }">
          {{ moment(item.registrationStartDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.registrationEndDate`]="{ item }">
          {{ moment(item.registrationEndDate).format("D-MMM-yyyy") }}
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip :color="item.isActive ? 'success' : 'grey'" size="small">
            {{ item.isActive ? "Active" : "Inactive" }}
          </v-chip>
        </template>
        <template v-slot:[`item.Actions`]="{ item }">
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn icon="mdi-dots-vertical" v-bind="props" size="small" variant="icon" />
            </template>
            <v-list density="compact">
              <v-list-item title="Edit" prepend-icon="mdi-pencil" @click="editMiqaat(item.miqaatId)" />
              <v-list-item title="Preview registration" prepend-icon="mdi-eye" @click="previewRegistration(item.miqaatId)" />
              <v-list-item title="Registrations" prepend-icon="mdi-account-group" @click="viewRegistrations(item.miqaatId)" />
              <v-list-item title="Export" prepend-icon="mdi-download" @click="exportRegistrations(item.miqaatId)" />
              <v-list-item title="Delete" prepend-icon="mdi-delete" class="text-error" @click="deleteItem(item)" />
            </v-list>
          </v-menu>
        </template>
      </data-table>
    </v-col>
  </v-row>

  <NewMiqaatDialog ref="dlgNewMiqaat" @saved="getData" />
</template>

<script setup>
import { reactive, ref, inject, onMounted } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import { getAll, deleteMiqaat, exportMiqaatRegistrations } from "@/services/miqaatService";
import NewMiqaatDialog from "./components/NewMiqaatDialog.vue";

const loader = inject("loader");
const snackbar = inject("snackBar");
const confirmDialog = inject("confirmDialog");
const router = useRouter();

const dlgNewMiqaat = ref(null);

const tableData = reactive({
  headers: [
    { title: "S. No", key: "SNo" },
    { title: "Miqaat Name", key: "miqaatName" },
    { title: "Start Date", key: "startDate" },
    { title: "End Date", key: "endDate" },
    { title: "Reg. Start", key: "registrationStartDate" },
    { title: "Reg. End", key: "registrationEndDate" },
    { title: "Active", key: "isActive" },
    { title: "Registrations", key: "registrationCount" },
    { title: "Actions", key: "Actions" },
  ],
  data: [],
});

async function getData() {
  loader.show();
  try {
    tableData.data = await getAll();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

function openNewMiqaat() {
  dlgNewMiqaat.value.show();
}

function editMiqaat(id) {
  router.push(`/miqaat-management/${id}/edit`);
}

function previewRegistration(id) {
  const url = router.resolve({
    path: `/miqaat-registration/${id}`,
    query: { preview: "1" },
  }).href;
  window.open(url, "_blank");
}

function viewRegistrations(id) {
  router.push(`/miqaat-approvals/central?miqaatId=${id}`);
}

async function exportRegistrations(id) {
  loader.show();
  try {
    const blob = await exportMiqaatRegistrations(id);
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `miqaat-registrations-${id}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

async function deleteItem(item) {
  const confirmed = await confirmDialog.confirm(
    "Delete Miqaat",
    `Are you sure you want to delete "${item.miqaatName}"?`,
    "Yes",
    "No",
    true
  );
  if (!confirmed) return;

  loader.show();
  try {
    await deleteMiqaat(item.miqaatId);
    snackbar.success("Miqaat deleted");
    await getData();
  } catch (error) {
    snackbar.error(error);
  } finally {
    loader.hide();
  }
}

onMounted(getData);
</script>
